import { Avatar, Box, Card, CardContent, IconButton, Stack } from '@mui/material'
import { hexWithOpacity, toTitleCase } from 'common/utils'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'
// import UserOptions from '../UserOptions/UserOptions'
import { EInviteStatus } from 'enum/EInviteStatus'
import useGlobalStyles from 'styles/globalStyles'
import RegistryUserItemOptions from './RegistryUserItemOptions'

interface Props {
  item: any;
  refetch?: () => void;
}
export default function RegistryUserItem({ item, refetch }: Props) {
  const globalStyles = useGlobalStyles();
  console.log('item', item)
  const u = item.end_user;

  const getStatusColor = (status: EInviteStatus) => {
    switch (status) {
      case EInviteStatus.ACCEPTED:
        return colors.success;
      case EInviteStatus.PENDING:
        return colors.warning;
      case EInviteStatus.REJECTED:
        return colors.error;
      default:
        return colors.text
    }
  }

  return (
    <Card
      key={item.id}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
        backgroundColor: '#fff',
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
        }}
      >
        {/* Top row */}
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>

          <Stack direction={'row'} justifyContent={'space-between'} spacing={1.5}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Avatar
                src={item?.user?.user_media?.image?.href_small}
                alt={`${item.user.name}`}
                sx={{
                  width: 38,
                  height: 38,
                  bgcolor: colors.avatarBg,
                }}
              />

            </Box>

            {/* User info */}
            <Stack
              direction='column'
              alignItems='start'
            >
              <CustomText
                text={`${item.user.name}`}
                color={colors.primary}
                fontSize={18}
                fontWeight={600}
                noWrap
              />

              <IconButton disableRipple sx={{ padding: 0 }}>
                <CustomText text={toTitleCase(item.status)} fontSize={12} color={getStatusColor(item.status)} />
              </IconButton>

            </Stack>
          </Stack>


          <RegistryUserItemOptions
            item={item}
            refetch={refetch}
          />
        </Stack>
      </CardContent>
    </Card>
  )
}